import { render, staticRenderFns } from "./ItemFileSetting.vue?vue&type=template&id=e4f6b58c&scoped=true&"
import script from "./ItemFileSetting.vue?vue&type=script&lang=js&"
export * from "./ItemFileSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f6b58c",
  null
  
)

export default component.exports